import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const ServiceabilitySettingsComponent = ({ selectLogisticsSettings, handleInnerFormChange }: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Hyperlocal"
                            name="Hyper local"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ServiceabilitySettings.Hyperlocal',
                                    selectLogisticsSettings?.ServiceabilitySettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.ServiceabilitySettings?.Hyperlocal}
                        />
                        <InputContainer
                            label="Inter City"
                            name="InterCity"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ServiceabilitySettings.InterCity',
                                    selectLogisticsSettings?.ServiceabilitySettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.ServiceabilitySettings?.InterCity}
                        />
                        <InputContainer
                            label="PanIndia"
                            name="PanIndia"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'ServiceabilitySettings.PanIndia',
                                    selectLogisticsSettings?.ServiceabilitySettings
                                )
                            }}
                            type="checkbox"
                            value={selectLogisticsSettings?.ServiceabilitySettings?.PanIndia}
                        />
                    </div>
                }
                expandedPanel="Serviceability Settings"
                headerTitle="Serviceability Settings"
            />
        </>
    )
}
export default ServiceabilitySettingsComponent;
